import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { IReportGroup, ReportGroup } from "@/models/report-group.entity";
import { MrfiktivReportGroupControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import Vue from "vue";
import { Action, Module, getModule } from "vuex-module-decorators";
import { ActionEnum } from "../enum/authActionEnum";
import { ResourceEnum } from "../enum/authResourceEnum";
import { PaginatedBaseStore } from "../paginated-base.store";
import { ReportGroupDataAccessLayer } from "./access-layers/report-group.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { ReportGroupPageDataProvider } from "./page-data-provider/report-group.page-data-provider.ts";
import { PartnerModule } from "./partner";
import { UserModule } from "./me-user.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "report-group",
  store
})
export class ReportGroupPaginationStore extends PaginatedBaseStore<
  IReportGroup,
  MrfiktivReportGroupControllerGetParamsGen
> {
  protected _data = ReportGroupDataAccessLayer;
  protected _pageProvider = ReportGroupPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = ReportGroup.filterables;

  @Action
  async reset(): Promise<void> {
    super.reset();
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.REPORT_GROUP, PartnerModule.partner.id)) {
      this.setFilters([]);
      await this.fetchFirstPage({ partnerId: PartnerModule.partner.id }).catch((e) => Vue.$log.error(e));
    }
  }
}

export const ReportGroupModule = getModule(ReportGroupPaginationStore);
